package games.polyclub.website.frontend.store.layout

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.img
import games.polyclub.frontend.lib.react.simplified.tags.span
import games.polyclub.website.frontend.store.sitemap.PublicSitemap
import react.Props
import react.router.dom.Link
import kotlin.text.Typography.nbsp

val SidebarLogo = SFC<Props> { _ ->
    Link("brand-link") {
        to = PublicSitemap.HOME.path
        img("brand-image") {
            src = "/img/logo.png"
            alt = "PolyClub"
            height = 213.84
            width = 33.0
        }
        span("brand-text font-weight-light") {
            +nbsp
        }
    }
}
